import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
  width: 100%;
  :hover {
    color: #ffffff;
    text-decoration: none;
  }
`;
